import { render, staticRenderFns } from "./TableTerminalesStatus.vue?vue&type=template&id=60f9e47a&"
import script from "./TableTerminalesStatus.vue?vue&type=script&lang=js&"
export * from "./TableTerminalesStatus.vue?vue&type=script&lang=js&"
import style0 from "./TableTerminalesStatus.vue?vue&type=style&index=0&id=60f9e47a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports